export const CLIENT_ACTIVE_ORG_STORAGE_KEY =
  "attendance_client_active_organization_id";

export function setClientPreferredOrganizationId(organizationId) {
  if (
    organizationId === null ||
    organizationId === undefined ||
    organizationId === ""
  ) {
    return;
  }
  sessionStorage.setItem(CLIENT_ACTIVE_ORG_STORAGE_KEY, String(organizationId));
}

export function clearClientPreferredOrganizationId() {
  sessionStorage.removeItem(CLIENT_ACTIVE_ORG_STORAGE_KEY);
}

function resolveClientOrganizationList(user) {
  if (Array.isArray(user?.organizations) && user.organizations.length) {
    return user.organizations;
  }

  if (Array.isArray(user?.organization)) {
    return user.organization;
  }

  return user?.organization ? [user.organization] : [];
}

export function applyPreferredOrganizationToUserPayload(user) {
  if (!user) return user;

  const orgList = resolveClientOrganizationList(user);
  const metaList = user.metadata || [];
  const withOrganizations = orgList.length
    ? { ...user, organizations: orgList }
    : user;

  const raw = sessionStorage.getItem(CLIENT_ACTIVE_ORG_STORAGE_KEY);
  if (!raw) return withOrganizations;

  const preferredId = Number(raw);
  if (!Number.isFinite(preferredId)) return withOrganizations;

  const hasOrgRecord = orgList.some(
    (o) => Number(o?.organization_id) === preferredId
  );
  const matchedOrgUser = metaList.find(
    (m) => Number(m?.organization_id) === preferredId
  );

  if (!hasOrgRecord || !matchedOrgUser?.organization_user_id) {
    return withOrganizations;
  }

  const activeOrg = orgList.find((o) => Number(o?.organization_id) === preferredId);

  const uaoSrc =
    user.user_active_organization || user.activeOrganization || {};
  const nextUao =
    typeof uaoSrc === "object" && uaoSrc !== null && !Array.isArray(uaoSrc)
      ? {
          ...uaoSrc,
          organization_id: preferredId,
          user_current_active_organization_id: preferredId,
        }
      : {
          organization_id: preferredId,
          user_current_active_organization_id: preferredId,
        };

  let nextActive = user.activeOrganization;
  if (
    nextActive &&
    typeof nextActive === "object" &&
    !Array.isArray(nextActive)
  ) {
    nextActive = {
      ...nextActive,
      organization_id: preferredId,
      user_current_active_organization_id: preferredId,
    };
  } else {
    nextActive = nextUao;
  }

  return {
    ...withOrganizations,
    organization: activeOrg ?? withOrganizations.organization,
    organizationuser: matchedOrgUser,
    user_active_organization: nextUao,
    activeOrganization: nextActive,
  };
}
